"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ForgotPasswordPage = void 0;
var react_1 = __importStar(require("react"));
var SplitPage_1 = require("@app/components/layout/SplitPage");
var ContainerPanel_1 = require("@app/components/layout/ContainerPanel");
var ForgotPasswordForm_1 = __importDefault(require("../components/ForgotPasswordForm"));
var react_redux_1 = require("react-redux");
var actions_1 = require("../state/actions");
var react_router_dom_1 = require("react-router-dom");
var YellowButton_1 = require("@app/components/controls/YellowButton");
var ForgotPasswordPage = /** @class */ (function (_super) {
    __extends(ForgotPasswordPage, _super);
    function ForgotPasswordPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleSubmit = function (email) {
            _this.props.onSubmitRequest(email);
        };
        _this.renderSuccessMessage = function (email) {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("p", { className: "has-text-centered" },
                    "An email from Blast@hasbro.com has been sent to ",
                    react_1.default.createElement("strong", null, email),
                    " with instructions to reset your password."),
                react_1.default.createElement("p", { className: "has-text-centered" },
                    "If you do not receive an email, please verify ",
                    react_1.default.createElement("strong", null, email),
                    " is correct; otherwise it may not be associated with a Blast account."),
                react_1.default.createElement("p", { className: "has-text-centered" },
                    react_1.default.createElement(react_router_dom_1.Link, { to: "/login" },
                        react_1.default.createElement(YellowButton_1.YellowButton, { type: "button", className: "button-large" }, "Finish")))));
        };
        return _this;
    }
    ForgotPasswordPage.prototype.render = function () {
        var fppState = this.props.location.state; // Forgot Password Page location state
        return (react_1.default.createElement(SplitPage_1.SplitPage, { title: "Forgot Password" },
            react_1.default.createElement(ContainerPanel_1.ContainerPanel, { title: "Forgot Your Password?", isLoading: this.props.isRequestingPasswordReset, className: "forgot-password" }, this.props.requestPasswordResetSuccess ?
                (this.renderSuccessMessage(fppState.email)) :
                (react_1.default.createElement(ForgotPasswordForm_1.default, { email: fppState.email, onSubmit: this.handleSubmit })))));
    };
    return ForgotPasswordPage;
}(react_1.Component));
exports.ForgotPasswordPage = ForgotPasswordPage;
var mapStateToProps = function (store) {
    return {
        isRequestingPasswordReset: store.auth.isRequestingPasswordReset,
        requestPasswordResetSuccess: store.auth.requestPasswordResetSuccess
    };
};
var mapDispatchToProps = {
    onSubmitRequest: actions_1.requestPasswordReset
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(ForgotPasswordPage);
